import styled, { css } from 'styled-components';

import alert from '../../../assets/alert.svg';
import colors from '../../../styles/colors';

interface containerProps {
  isRequired?: boolean;
}

export const Container = styled.div<containerProps>`
  display: flex;
  flex-direction: column;
  flex: 1;
  > div:first-child {
    margin: 10px 0 5px 0;
    label {
      font-weight: normal;
      ${(props) =>
        props.isRequired &&
        css`
          font-weight: bold;
        `}
    }
    small {
      color: ${colors.gray};
      font-size: 14px;
    }
  }

  > div {
    margin: 10px 0 5px 0;
    label {
      font-weight: bold;
    }
    small {
      color: ${colors.gray};
      font-size: 14px;
    }
  }

  input {
    width: 100%;
    border-radius: 5px;
    border: 1px solid ${colors.gray};
    background: transparent;
    height: 50px;
    padding: 0 15px;
    transition: border 0.3s;
    &::placeholder {
      color: ${colors.gray};
    }
    &:focus {
      border: solid 1px ${colors.darkgray};
    }
    &:disabled {
      background: #f2f2f2;
    }
  }
  span {
    color: #c11e1e;
    margin: 5px 0;
  }
  span:before {
    content: url(${alert});
    padding: 0 10px 0 0;
    vertical-align: -10%;
  }
`;
